import { ref } from 'vue';
import { useToast } from '@/composables/common/useToast';
import { useQueryList as useListQuery } from '@/composables/common/useQueryList';
import indumentariaService from '@/services/admin/bases/indumentarias';

export function useIndumentariasIndex() {
    const toast = useToast();

    const list = useListQuery({
        fetcher: async params => {
            const result = await indumentariaService.getIndumentarias({
                lista_id: params.lista_id,
                page: params.filters.page,
                per_page: params.filters.per_page,
                filters: {
                    search: params.filters.search || undefined,
                    talla: params.filters.talla || undefined,
                },
            });
            return { data: result.items, meta: result.meta };
        },
        extraFilters: ['talla'],
        watchListaId: true,
    });

    const tallas = ref([]);

    async function fetchTallas(lista_id) {
        try {
            const result = await indumentariaService.getTallas({
                lista_id: lista_id || list.listaId.value,
            });
            tallas.value = Array.isArray(result) ? result : [];
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error('[useIndumentariasIndex] Error fetching tallas:', error);
            }
        }
    }

    async function borrar(indumentariaId) {
        try {
            const res = await indumentariaService.deleteIndumentaria({
                lista_id: list.listaId.value,
                indumentaria_id: indumentariaId,
            });
            toast.success(res.data?.message || 'Indumentaria eliminada correctamente');
            list.fetch();
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Error al eliminar la indumentaria');
        }
    }

    return {
        indumentarias: list.data,
        loading: list.loading,
        tallas,
        filters: list.filters,
        listaId: list.listaId,
        fetch: list.fetch,
        fetchTallas,
        borrar,
        debouncedFetch: list.debouncedFetch,
    };
}
